var _defs, _g, _polyline;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpiReboot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #be1e2d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 32,
    cy: 32.18,
    rx: 28.7,
    ry: 28.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m43.34,43.22c-.08.09-.17.18-.25.26-.08.09-.16.18-.24.27.16-.18.33-.35.49-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.28,45.89c-.1.06-.2.13-.31.19-.1.07-.2.13-.31.2.2-.13.41-.26.61-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m36.62,47.71c-.11.04-.23.07-.34.1-.12.04-.24.08-.36.12.23-.07.47-.15.7-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m32.53,48.53c-.12,0-.24,0-.37.01-.13,0-.26.02-.39.02.25-.01.51-.02.76-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m45.65,39.83c-.06.11-.12.22-.18.33-.05.11-.11.21-.17.32.12-.22.23-.43.35-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.35,46.87c-.11-.06-.22-.12-.33-.18-.11-.05-.21-.11-.32-.17.22.12.43.23.65.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.48,27.56c.04.11.07.23.1.34.04.12.08.24.12.36-.07-.23-.15-.47-.22-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m47.02,35.87c-.03.13-.06.26-.09.38-.02.12-.05.24-.08.36.06-.25.11-.49.17-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.66,23.9c.06.1.13.2.19.31.07.1.13.2.2.31-.13-.2-.26-.41-.39-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m47.3,31.65c0,.12,0,.24.01.37,0,.13.02.26.02.39-.01-.25-.02-.51-.03-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m28.31,48.24c-.13-.03-.26-.06-.38-.09-.12-.02-.24-.05-.36-.08.25.06.49.11.74.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20.96,44.57c-.09-.08-.18-.17-.26-.25-.09-.08-.18-.16-.27-.24.18.16.35.33.53.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.94,29.54c.03-.13.06-.26.09-.38.02-.12.05-.24.08-.36-.06.25-.11.49-.17.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m17.31,25.57c.06-.11.12-.22.18-.33.05-.11.11-.21.17-.32-.12.22-.23.43-.35.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m32,.54c-7.21,0-13.86,2.43-19.16,6.52h0C5.39,12.8.58,21.82.58,31.95c0,17.35,14.07,31.42,31.42,31.42s31.42-14.07,31.42-31.42S49.35.54,32,.54Zm-3.18,9.19h5.83v24.71h-5.83V9.72Zm24.05,24.94c-.15,1.67-.51,3.34-1.04,4.92-.51,1.54-1.23,3.02-2.08,4.4-.97,1.59-2.18,3.03-3.52,4.32-1.34,1.29-2.87,2.37-4.49,3.27-1.64.91-3.42,1.57-5.23,2.02-1.87.47-3.82.63-5.75.58-1.96-.05-3.92-.41-5.79-.99-1.8-.56-3.53-1.4-5.13-2.41-1.57-.99-3-2.23-4.25-3.59-1.25-1.36-2.32-2.92-3.19-4.55-.88-1.65-1.51-3.45-1.93-5.28-.43-1.88-.57-3.85-.48-5.77.04-.87.14-1.74.3-2.6.2-1.07.45-2.13.79-3.16.59-1.79,1.46-3.51,2.5-5.07,1.03-1.54,2.28-2.96,3.67-4.18.02-.02.05-.04.07-.06.06,2.28.69,4.43,1.75,6.33-.6.76-1.14,1.57-1.61,2.41-.63,1.25-1.12,2.56-1.46,3.91-.29,1.39-.42,2.81-.39,4.23.09,1.39.33,2.77.73,4.11.44,1.29,1.02,2.53,1.73,3.7.75,1.13,1.62,2.17,2.6,3.12,1.02.91,2.13,1.7,3.32,2.37,1.24.63,2.56,1.12,3.91,1.46,1.39.29,2.81.42,4.23.39,1.39-.09,2.77-.33,4.11-.73,1.29-.44,2.53-1.02,3.7-1.73,1.13-.75,2.17-1.62,3.12-2.6.91-1.02,1.7-2.13,2.37-3.32.63-1.25,1.12-2.56,1.46-3.91.14-.7.25-1.4.31-2.11.06-.71.09-1.42.07-2.13-.09-1.39-.33-2.77-.73-4.11-.44-1.29-1.02-2.53-1.73-3.7-.43-.64-.89-1.26-1.39-1.84.77-1.52,1.28-3.21,1.44-5.01.04-.47.06-.93.06-1.39.24.2.48.4.71.62.77.7,1.52,1.42,2.2,2.22.53.62,1.02,1.28,1.46,1.96.57.88,1.11,1.76,1.56,2.71,1.65,3.46,2.33,7.37,1.99,11.19Zm-9.23-11.93c.15.19.3.38.44.57-.07-.1-.15-.19-.23-.29-.07-.1-.14-.19-.22-.29Zm2.14,3.48c.1.23.19.45.29.68-.05-.11-.1-.23-.15-.34-.04-.11-.09-.22-.14-.33Zm1.19,4c.03.25.07.5.1.75-.02-.13-.04-.26-.06-.39-.01-.12-.03-.24-.04-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.65,33.76c0-.12,0-.24-.01-.37,0-.13-.02-.26-.02-.39.01.25.02.51.03.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m16.47,37.85c-.04-.11-.07-.23-.1-.34-.04-.12-.08-.24-.12-.36.07.23.15.47.22.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.29,41.51c-.06-.1-.13-.2-.19-.31-.07-.1-.13-.2-.2-.31.13.2.26.41.39.61Z"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "20.81 26.95 11.6 16.73 23.45 15.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpiReboot);
export default __webpack_public_path__ + "static/media/epiReboot.6a036e47be9fcabf156f4cdb9b711794.svg";
export { ForwardRef as ReactComponent };